export enum DashboardTabTriggers {
  REFERRAL = "referral",
  COLLAB = "collab",
  WITHDRAW = "withdraw",
}

export const calculateScratchPercentage = (imageData: ImageData): number => {
  const pixels = imageData.data;
  let transparent = 0;

  for (let i = 0; i < pixels.length; i += 4) {
    if (pixels[i + 3] === 0) transparent++;
  }

  return (transparent / (pixels.length / 4)) * 100;
};

export const getRewardForReferral = (followers: number): number => {
  if (!followers || followers === 0) {
    return 0;
  }

  console.log(followers);

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function determineReward(tier) {
    const rewards = {
      "Tier 1": [
        { range: [76, 99], probability: 0.1 },
        { range: [51, 75], probability: 0.2 },
        { range: [26, 49], probability: 0.3 },
        { range: [6, 25], probability: 0.2 },
        { range: [0, 0], text: "Better luck next time", probability: 0.2 },
      ],
      "Tier 2": [
        { range: [51, 75], probability: 0.15 },
        { range: [36, 50], probability: 0.2 },
        { range: [16, 35], probability: 0.2 },
        { range: [6, 15], probability: 0.2 },
        { range: [0, 0], text: "Better luck next time", probability: 0.25 },
      ],
      "Tier 3": [
        { range: [36, 50], probability: 0.15 },
        { range: [26, 35], probability: 0.2 },
        { range: [16, 25], probability: 0.2 },
        { range: [6, 15], probability: 0.15 },
        { range: [0, 0], text: "Better luck next time", probability: 0.3 },
      ],
      "Tier 4": [
        { range: [26, 35], probability: 0.15 },
        { range: [16, 25], probability: 0.15 },
        { range: [11, 15], probability: 0.15 },
        { range: [6, 10], probability: 0.2 },
        { range: [0, 0], text: "Better luck next time", probability: 0.35 },
      ],
      "Tier 5": [
        { range: [16, 25], probability: 0.15 },
        { range: [11, 15], probability: 0.2 },
        { range: [6, 10], probability: 0.25 },
        { range: [0, 0], text: "Better luck next time", probability: 0.4 },
      ],
    };

    const outcomes = rewards[tier];
    let cumulativeProbability = 0;
    const randomValue = Math.random();
    for (const outcome of outcomes) {
      cumulativeProbability += outcome.probability;
      if (randomValue <= cumulativeProbability) {
        const reward = getRandomInt(outcome.range[0], outcome.range[1]);
        console.log("reward", reward);
        return reward;
      }
    }

    return 0;
  }

  function assignReward(followers) {
    let tier;
    if (followers >= 100000) {
      tier = "Tier 1";
    } else if (followers >= 70000) {
      tier = "Tier 2";
    } else if (followers >= 40000) {
      tier = "Tier 3";
    } else if (followers >= 20000) {
      tier = "Tier 4";
    } else {
      tier = "Tier 5";
    }

    console.log("tier", tier);

    return determineReward(tier);
  }

  const reward = assignReward(followers);

  return reward;
};
